var base = require('settings/teams/send-invitation');

Vue.component('spark-send-invitation', {
    mixins: [base],

    data() {
        return {
            plans: [],

            roles: []
        };
    },

    created() {
        this.getPlans();

        this.getRoles();
    },

    methods: {
        /**
         * Get all the plans defined in the application.
         */
        getPlans() {
            axios.get('/spark/plans')
                .then(response => {
                    this.plans = response.data;
                });
        },

        /**
         * Get the available member roles.
         */
        getRoles() {
            axios.get(`/settings/${Spark.teamsPrefix}/roles`)
                .then(response => {
                    this.roles = response.data.filter(item => item.value !== 'developer');
                });
        }
    }
});
